/************ MANAGED INTEGRATION KEYS  ************/
export const getManagedIntegrationKey = () => ['managedIntegration'] as const;

export const getManagedIntegrationListKey = () =>
  [...getManagedIntegrationKey(), 'list'] as const;

export const getManagedIntegrationDetailsKey = (
  managedIntegrationUuid: string,
) =>
  [...getManagedIntegrationKey(), 'details', managedIntegrationUuid] as const;

/************ ACTION DEFINITION KEYS  ************/

export const getActionDefinitionKey = () => ['actionDefinition'] as const;

export const getActionDefinitionListKey = () =>
  [...getActionDefinitionKey(), 'list'] as const;

export const getActionDefinitionDetailsKey = (actionDefinitionUuid: string) =>
  [...getActionDefinitionKey(), 'details', actionDefinitionUuid] as const;

/************ INTEGRATION ACTIONS KEYS  ************/

export const getIntegrationActionKey = (managedIntegrationUuid: string) =>
  [
    ...getManagedIntegrationKey(),
    managedIntegrationUuid,
    'integrationAction',
  ] as const;

export const getIntegrationActionListKey = (managedIntegrationUuid: string) =>
  [...getIntegrationActionKey(managedIntegrationUuid), 'list'] as const;

export const getIntegrationActionDetailsKey = (integrationActionUuid: string) =>
  [...getActionDefinitionKey(), 'details', integrationActionUuid] as const;

/************ INTEGRATION TEMPLATE KEYS  ************/

export const getIntegrationTemplateKey = () => ['integrationTemplate'] as const;

export const getIntegrationTemplateListKey = () =>
  [...getIntegrationTemplateKey(), 'list'] as const;

export const getIntegrationTemplateDetailsKey = (
  integrationTemplateUuid: string,
) =>
  [...getIntegrationTemplateKey(), 'details', integrationTemplateUuid] as const;

/************ INTEGRATION TEMPLATE LOGO KEYS  ************/

export const getIntegrationTemplateLogoKey = () =>
  ['integrationTemplateLogo'] as const;

export const getIntegrationTemplateLogoListKey = () =>
  [...getIntegrationTemplateLogoKey(), 'list'] as const;

export const getIntegrationTemplateLogoDetailsKey = (
  integrationTemplateLogoUuid: string,
) =>
  [
    ...getIntegrationTemplateLogoKey(),
    'details',
    integrationTemplateLogoUuid,
  ] as const;

/************ SCHEDULED ACTION REQUESTS  ************/

export const getScheduledActionRequestKey = (managedIntegrationUuid: string) =>
  [
    ...getManagedIntegrationKey(),
    managedIntegrationUuid,
    'scheduledActionRequest',
  ] as const;

export const getScheduledActionRequestListKey = (
  managedIntegrationUuid: string,
) => [...getScheduledActionRequestKey(managedIntegrationUuid), 'list'] as const;

/************** API MEMBER KEYS ***************/

export const getApiMemberKey = () => ['apiMember'] as const;

export const getApiMembersListKey = () =>
  [...getApiMemberKey(), 'list'] as const;

export const getApiMemberDetailsKey = (apiMemberId: string) =>
  [...getApiMemberKey(), 'details', apiMemberId] as const;

/************** WEBHOOK KEYS ***************/

export const getWebhookKey = () => ['webhook'] as const;

export const getWebhookDetailsKey = (webhookUuid: string) =>
  [...getWebhookKey(), 'details', webhookUuid] as const;

export const getWebhookDispatchesKey = () =>
  [
    ...getWebhookKey(),
    'dispatches',
    // webhookUuid,
  ] as const;

export const getWebhookDispatchesListKey = () =>
  [...getWebhookDispatchesKey(), 'list'] as const;

export const getWebhookDispatchesDetailsKey = () =>
  [...getWebhookDispatchesKey(), 'details'] as const;

export const getWebhookSecretKey = (webhookUuid: string) =>
  [...getWebhookKey(), 'secret', webhookUuid] as const;

export const getWebhookListKey = () => [...getWebhookKey(), 'list'] as const;
